/**
 * Может ли текущий пользователь писать (мутировать) чат: backend разрешает
 * только владельцу чата или суперадмину (manager-видимые чужие чаты — read-only).
 *
 * Fail-closed: если владелец чата или текущий пользователь ещё неизвестны
 * (загрузка/ошибка), возвращаем `false` и прячем действия в UI.
 */
export function canWriteChat(
    ownerUserId: string | null | undefined,
    currentUser: { id?: string | null; isSuperAdmin?: boolean } | null | undefined,
): boolean {
    if (!ownerUserId || !currentUser?.id) return false;
    if (currentUser.isSuperAdmin === true) return true;
    return currentUser.id === ownerUserId;
}
